import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout/Layout.vue'

Vue.use(Router)

/**
 * constantRoutes
 *没有权限要求的基本页面
 *可以访问所有角色
 */
export const constantRouterMap = [
	{
	    path: '/login',
		meta: { title: '后台登录',icon:"s-tools" },
	    component: () => import('@/page/login/login'),
	},
	{
	    path: '/',
	    component: Layout,
	    meta: { title: '后台首页',icon:"s-home" },
	    children: [
	        {path: '/',component: () => import('@/page/Dashboard'),meta: { title: '后台首页'}},
	    ]
	},
	

]
/**
 * asyncRoutes
 * 需要根据用户角色动态加载的路由
 * path必须为唯一否则其他管理员生成路由可能会有bug。
 */
export var asyncRoutes = [
	{
		title:'签单岛 - 合作商',
	    path: '/sign_shop/',
	    component: Layout,
	    meta: { title: '签单岛 - 合作商',icon:"document" },
	    children: [
			{title:'分组管理',path: 'group_list',component: () => import('@/page/sign_shop/group_list'),meta: { title: '分组管理'}},
			{title:'签单管理',path: 'doc',component: () => import('@/page/sign_shop/doc'),meta: { title: '签单管理'}},
			// {title:'充值',path: 'recharge_pay',component: () => import('@/page/sign_shop/recharge_pay'),meta: { title: '充值'}},
			// {title:'充值明细',path: 'recharge_list',component: () => import('@/page/sign_shop/recharge_list'),meta: { title: '充值明细'}},
			{title:'资金明细',path: 'br_details',component: () => import('@/page/sign_shop/br_details'),meta: { title: '资金明细'}},
			// {title:'Excel面单上传',path: 'excel_doc',component: () => import('@/page/sign_shop/excel_doc'),meta: { title: 'Excel面单上传'}},
	    ]
	},
	{
		title:'签单岛 - 管理端',
	    path: '/sign_admin/',
	    component: Layout,
	    meta: { title: '签单岛 - 管理端',icon:"present" },
	    children: [
			{title:'订单列表',path: 'sign_order_list',component: () => import('@/page/sign_admin/sign_order_list'),meta: { title: '订单列表'}},
			{title:'签收列表',path: 'sign_order_sign_list',component: () => import('@/page/sign_admin/sign_order_sign_list'),meta: { title: '签收列表'}},
			// {title:'签单岛 - 系统设置',path: 'sign_sys_set',component: () => import('@/page/sign_admin/sys_set'),meta: { title: '签单岛 - 系统设置'}},
			// {title:'签单岛 - 充值列表',path: 'sign_recharge',component: () => import('@/page/sign_admin/sign_recharge'),meta: { title: '签单岛 - 充值列表'}},
			{title:'签单岛 - 余额记录',path: 'sign_br_list',component: () => import('@/page/sign_admin/sign_br_list'),meta: { title: '签单岛 - 余额记录'}},
			{title:'签单岛 - 平台设置',path: 'sign_platform',component: () => import('@/page/sign_admin/sign_platform'),meta: { title: '签单岛 - 平台设置'}},
			{title:'签单岛 - 国家设置',path: 'sign_country',component: () => import('@/page/sign_admin/sign_country'),meta: { title: '签单岛 - 国家设置'}},
			{title:'特殊佣金设置',path: 'sign_commission_money',component: () => import('@/page/sign_admin/sign_commission_money'),meta: { title: '特殊佣金设置'}},
			{title:'角色',path: 'sign_role',component: () => import('@/page/sign_admin/sign_role'),meta: { title: '角色'}},
			{title:'用户',path: 'sign_manager_list',component: () => import('@/page/sign_admin/sign_manager_list'),meta: { title: '用户'}},
			{title:'充值 / 扣款',path: 'sign_br_change',component: () => import('@/page/sign_admin/sign_br_change'),meta: { title: '充值 / 扣款'}},
			{title:'抽成记录',path: 're_money_list',component: () => import('@/page/sign_admin/re_money_list'),meta: { title: '抽成记录'}},
			{title:'提现账户设置',path: 'account',component: () => import('@/page/sign_admin/account'),meta: { title: '提现账户设置'}},
			{title:'提现记录',path: 'withdrawal_list',component: () => import('@/page/sign_admin/withdrawal_list'),meta: { title: '提现记录'}},
			{title:'提现审核',path: 'withdrawal_sh',component: () => import('@/page/sign_admin/withdrawal_sh'),meta: { title: '提现审核'}},
			{title:'每日统计',path: 'day_total',component: () => import('@/page/sign_admin/day_total'),meta: { title: '每日统计'}},
	    ]
	},
]
export default new Router({
    // mode: 'history', //后端支持可开
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap
})